// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tl-0";
export var checkoutRateBadgeLink = "_tl-1";